import { render, staticRenderFns } from "./boxRechange.vue?vue&type=template&id=31ba186a&scoped=true&"
import script from "./boxRechange.vue?vue&type=script&lang=ts&"
export * from "./boxRechange.vue?vue&type=script&lang=ts&"
import style0 from "./boxRechange.vue?vue&type=style&index=0&id=31ba186a&prod&lang=less&scoped=true&"
import style1 from "./boxRechange.vue?vue&type=style&index=1&id=31ba186a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba186a",
  null
  
)

export default component.exports